import { render, staticRenderFns } from "./aStaffDetailCommunitys.vue?vue&type=template&id=8bc3e90a"
import script from "./aStaffDetailCommunitys.vue?vue&type=script&lang=js"
export * from "./aStaffDetailCommunitys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports